import { toast } from "react-toastify";
import {
  SECTION_ADD_SUCCESS,
  SECTION_ADD_REQUEST,
  SECTION_ADD_FAIL,
  //
  SECTION_LIST_SUCCESS,
  SECTION_LIST_REQUEST,
  SECTION_LIST_FAIL,
  //
  SECTION_DETAIL_SUCCESS,
  SECTION_DETAIL_REQUEST,
  SECTION_DETAIL_FAIL,
  //
  SECTION_DELETE_SUCCESS,
  SECTION_DELETE_REQUEST,
  SECTION_DELETE_FAIL,
  //
  SECTION_UPDATE_SUCCESS,
  SECTION_UPDATE_REQUEST,
  SECTION_UPDATE_FAIL,
  //
  SECTION_STORE_LIST_SUCCESS,
  SECTION_STORE_LIST_REQUEST,
  SECTION_STORE_LIST_FAIL,

  //
} from "../constants/sectionConstants";

export const getListSectionByStoreReducer = (
  state = { sections: [] },
  action
) => {
  switch (action.type) {
    case SECTION_STORE_LIST_REQUEST:
      return { loadingListSection: true, sections: [] };
    case SECTION_STORE_LIST_SUCCESS:
      return {
        loadingListSection: false,
        sections: action.payload.sections,
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case SECTION_STORE_LIST_FAIL:
      return {
        loadingListSection: false,
        errorListSection: action.payload,
      };
    case "RESET_SECTION":
      return { loadingListSection: false, sections: [] };
    default:
      return state;
  }
};

export const deleteSectionReducer = (state = {}, action) => {
  switch (action.type) {
    case SECTION_DELETE_REQUEST:
      return { loadingSectionDelete: true };
    case SECTION_DELETE_SUCCESS:
      toast.success("This Section has been successfully deleted.");
      return {
        loadingSectionDelete: false,
        successSectionDelete: true,
      };
    case SECTION_DELETE_FAIL:
      return {
        loadingSectionDelete: false,
        errorSectionDelete: action.payload,
        successSectionDelete: false,
      };
    default:
      return state;
  }
};

export const updateCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case SECTION_UPDATE_REQUEST:
      return { loadingCategoryUpdate: true };
    case SECTION_UPDATE_SUCCESS:
      toast.success("This Category has been successfully updated");
      return {
        loadingCategoryUpdate: false,
        successCategoryUpdate: true,
      };
    case SECTION_UPDATE_FAIL:
      return {
        loadingCategoryUpdate: false,
        errorCategoryUpdate: action.payload,
        successCategoryUpdate: false,
      };
    default:
      return state;
  }
};

export const detailCategoryReducer = (state = { categoryInfo: {} }, action) => {
  switch (action.type) {
    case SECTION_DETAIL_REQUEST:
      return { loadingCategoryInfo: true };
    case SECTION_DETAIL_SUCCESS:
      return {
        loadingCategoryInfo: false,
        successCategoryInfo: true,
        categoryInfo: action.payload.category,
      };
    case SECTION_DETAIL_FAIL:
      return {
        loadingCategoryInfo: false,
        successCategoryInfo: false,
        errorCategoryInfo: action.payload,
      };
    default:
      return state;
  }
};

export const createNewSectionReducer = (state = {}, action) => {
  switch (action.type) {
    case SECTION_ADD_REQUEST:
      return { loadingSectionAdd: true };
    case SECTION_ADD_SUCCESS:
      toast.success("This Section has been added successfully");
      return {
        loadingSectionAdd: false,
        successSectionAdd: true,
      };
    case SECTION_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingSectionAdd: false,
        successSectionAdd: false,
        errorSectionAdd: action.payload,
      };
    default:
      return state;
  }
};

export const getListSectionReducer = (state = { sections: [] }, action) => {
  switch (action.type) {
    case SECTION_LIST_REQUEST:
      return { loadingListSection: true, sections: [] };
    case SECTION_LIST_SUCCESS:
      return {
        loadingListSection: false,
        sections: action.payload.sections,
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case SECTION_LIST_FAIL:
      return {
        loadingListSection: false,
        errorListSection: action.payload,
      };
    default:
      return state;
  }
};
